module.exports = __webpack_public_path__ + "static/img/pay-bg.be2fdda8.png";